import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'gc-label-value-presentation',
  templateUrl: './label-value-presentation.component.html',
  styleUrl: './label-value-presentation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass],
  host: {
    class: 'w-full',
  },
})
export class LabelValuePresentationComponent {
  label = input.required<string>();
  stacked = input<boolean>(false);
  highlight = input<boolean>(false);
}
